var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9.25H2.25C1.82812 9.25 1.5 8.92188 1.5 8.5V2.5C1.5 2.10156 1.82812 1.75 2.25 1.75H3.75C4.14844 1.75 4.5 1.42188 4.5 1C4.5 0.601562 4.14844 0.25 3.75 0.25H2.25C0.984375 0.25 0 1.25781 0 2.5V8.5C0 9.76562 0.984375 10.75 2.25 10.75H3.75C4.14844 10.75 4.5 10.4219 4.5 10C4.5 9.60156 4.14844 9.25 3.75 9.25ZM11.7656 4.98438L8.76562 1.98438C8.48438 1.67969 7.99219 1.67969 7.71094 1.98438C7.40625 2.26562 7.40625 2.75781 7.71094 3.03906L9.42188 4.75H4.5C4.07812 4.75 3.75 5.10156 3.75 5.5C3.75 5.92188 4.07812 6.25 4.5 6.25H9.42188L7.71094 7.98438C7.40625 8.26562 7.40625 8.75781 7.71094 9.03906C7.99219 9.34375 8.48438 9.34375 8.76562 9.03906L11.7656 6.03906C12.0703 5.75781 12.0703 5.26562 11.7656 4.98438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.aaf6391708263a6b25d14eaed6829a07.svg";
export { ForwardRef as ReactComponent };